import { render, staticRenderFns } from "./addaddress.vue?vue&type=template&id=5c528ae8&scoped=true"
import script from "./addaddress.vue?vue&type=script&lang=js"
export * from "./addaddress.vue?vue&type=script&lang=js"
import style0 from "./addaddress.vue?vue&type=style&index=0&id=5c528ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c528ae8",
  null
  
)

export default component.exports